/**
 * @fileoverview GET handler for the "/comments/:target/notification_setting" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { commentsTargetNotificationSetting } from "./constants";
import type { CommentsNotificationSettingResult } from "./types";

export const getCommentsNotificationSetting = reactQueryFetcherAdapter(
  commentsTargetNotificationSetting,
  (signal: AbortSignal, target: string, appGroupId: string): Promise<CommentsNotificationSettingResult> => {
    return fetch(`/comments/${target}/notification_setting`, "GET", { app_group_id: appGroupId }, { signal });
  }
);
